

export function isNullOrUndefined(value: any) {
    return value == null || value == undefined;
}

/**
 * Encodes HTML as "b64:" + Base64(UTF-8) so request bodies don't trip WAF XSS rules.
 * The API (UserService.DecodeEmailSignature) decodes values carrying this prefix.
 */
export function encodeHtmlForWaf(html: string): string {
    if (html == null || html === '') {
        return html;
    }
    const bytes = new TextEncoder().encode(html);
    let binary = '';
    bytes.forEach(b => binary += String.fromCharCode(b));
    return 'b64:' + btoa(binary);
}
export function isUndefined(value:any){
   return  value == undefined;
}
export function isNotNullOrUndefined(value:any){
    return !isNullOrUndefined(value);
}
export function getDateAsUTC(localDate: Date): Date {
    // Converts passed dates timezone to UTC and then return local of that date.
    if (isNullOrUndefined(localDate)) {
        return localDate;
    }
    return new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), 0, 0, 0));
}

export function getUTCDate(localDate: Date): Date {
    // Get UTC date part alone of the passed date and returns local date of that
    if (isNullOrUndefined(localDate)) {
        return localDate;
    }
    return new Date(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate(), 0, 0, 0);
}

export const DEFAULT_EDITOR_TOOLBAR_CONFIG = {

    plugins: 'lists link table advlist quickbars inlinecss',
    toolbar: 'undo redo | fontsize styles | bold italic underline | forecolor backcolor  removeformat table | numlist bullist | alignleft aligncenter alignright alignjustify ltr rtl | outdent indent |',
    height: 600,
    content_style: 'body { font-size:10.0pt;line-height:115%;font-family:EYInterstate Light }',
    fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
    color_map: [
        '000000', 'Black',
        '808080', 'Gray',
        'FFFFFF', 'White',
        'FF0000', 'Red',
        'FFFF00', 'Yellow',
        '008000', 'Green',
        '0000FF', 'Blue'
    ],
    menubar: false,
    statusbar: false,
    auto_focus: 'true',
    convert_urls: false,    
    browser_spellcheck: true,
    table_toolbar: '',
};

export const DEFAULT_TMPL_EDITOR_TOOLBAR_CONFIG = {
    plugins: 'link table lists preview ph noneditable code inlinecss',
    noneditable_noneditable_class: "readonly-eosph",
    toolbar: 'ph | undo redo | fontsize styles | bold italic underline | forecolor backcolor  removeformat table | numlist bullist | alignleft aligncenter alignright alignjustify ltr rtl | outdent indent | preview | code',
    height: 600,
  content_style: 'body { font-size:10.0pt;line-height:115%;font-family:EYInterstate Light } eos-ph { color:red; border-style: dotted; }',
    fontsize_formats: "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt",
    color_map: [
        '000000', 'Black',
        '808080', 'Gray',
        'FFFFFF', 'White',
        'FF0000', 'Red',
        'FFFF00', 'Yellow',
        '008000', 'Green',
        '0000FF', 'Blue'
    ],
   extended_valid_elements: "eos-ph[key|class],eos-section[key|value]",
    custom_elements: "eos-section",
    menubar: false,
    table_toolbar: '',
    statusbar: false,
    auto_focus: false,
    convert_urls: false,
    browser_spellcheck: true,
    contextmenu: 'ph | link | table'

};

export const DEFAULT_INLINE_TMPL_EDITOR_TOOLBAR_CONFIG = {
    inline: true,
    plugins: 'ph noneditable',
    noneditable_noneditable_class: "readonly-eosph",
    contextmenu: 'ph',
    toolbar: '',
    forced_root_block: '',
    content_style: 'eos-sph { color:red; border-style: dotted; }',
    valid_elements: 'eos-sph[key|class]',
    extended_valid_elements: 'eos-sph[key|class]',
    menubar: false,    
    browser_spellcheck: true,
    statusbar: false,
   
};

export const DEFAULT_INLINE_Mail_TMPL_EDITOR_TOOLBAR_CONFIG = {
  inline: true,
  plugins: 'phMail noneditable',
  contextmenu: 'ph',
  noneditable_noneditable_class: "readonly-eosph",
  toolbar: '',
  forced_root_block: '',
  content_style: 'eos-sph { color:red; border-style: dotted; }',
  valid_elements: 'eos-sph[key|class]',
  extended_valid_elements: 'eos-sph[key|class]',
  menubar: false,
  browser_spellcheck: true,
  statusbar: false,
};
